import { gql } from '@apollo/client';

const GET_COMPLIANCE = {
  query: gql`
    query GetCompliance($entityId: ID!, $entityType: EntityType!, $country: Country) {
      getCompliance(entityId: $entityId, entityType: $entityType, country: $country) {
        uuid
        status
        entityType
        country
        entityId
        documents {
          name
          format
          documentStatus
          uploadDate
          expirationDate
          path
          entityType
        }
        notes
      }
    }
  `,
  policies: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
};

export default GET_COMPLIANCE;
